// CONSTANTS are all caps.
const NS = "FeatureArticleHero";
const CLS = "featureArticleHero";
const WG = `.${CLS}-`;

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/featureArticleHero.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'

import utils from '../utils';

export class FeatureArticleHero {

	constructor($el) {
		// $el is the widget node return by the loadFeatureArticleHero function
		this.$el = $($el);
	}

	init() {
		this.playVideo();
		this.setImageHeight();
	}

	playVideo() {
		$(document).on("youtubeVideoReady", () => {
			let $video = this.$el.find(`${WG}video`);
			if ($video.length > 0) {
				youTubePlayers[$video.attr("data-array-index")].setVolume(0);
			}
		});
	}

	setImageHeight() {
		//there's a bu on iframe for using "vh" unit. so need to override it using pixel
		if ((utils.isIPhone() || utils.isIPad()) && utils.inIframe()) {
			var h = window.top.innerHeight || 530;			
			this.$el.css('height', `${h}px`);
			if (utils.isIPhone()) this.$el.find(WG + 'chev').css('bottom', '50px');
		}
	}

}
